import { AxiosInstance } from 'axios';
import { result, Result } from 'util/result';
import Terra from '../Terra';
import { UserRole, UserRoleDescription } from 'data/terra/UserRole';
import { UpsertUserRequest, User } from 'data/terra/User';
import {
  UserResponse,
  UsersResponse,
} from 'data/terra/api/terra/response/UserResponse';
import {
  UserRolesResponse,
  UserRoleResponse,
} from 'data/terra/api/terra/response/UserRoleResponse';
import {
  ProductUserResponse,
  ProductUsersResponse,
} from 'data/terra/api/terra/response/ProductUserResponse';

class UserEndpoint {
  getUsersUrl = () => `${Terra.TERRA_HOST}/${Terra.TERRA_BASE_API_URL}/users`;
  getUserRolesUrl = () =>
    `${Terra.TERRA_HOST}/${Terra.TERRA_BASE_API_URL}/roles`;
  getProductUsersUrl = (productId: string) =>
    `${Terra.TERRA_HOST}/${Terra.TERRA_BASE_API_URL}/products/${productId}/users`;
  getProductUserDetailUrl = (productId: string, userId: string) =>
    `${Terra.TERRA_HOST}/${Terra.TERRA_BASE_API_URL}/products/${productId}/users/${userId}`;
}


export class UserApi {
  terraClient: AxiosInstance;
  endpoint = new UserEndpoint();

  constructor(client: AxiosInstance) {
    this.terraClient = client;
  }

  searchUser(query: string): Promise<Result<UsersResponse>> {
    return result(
      async () =>
        (
          await this.terraClient.get<UsersResponse>(
            this.endpoint.getUsersUrl(),
            {
              params: {
                filter: query,
              },
            }
          )
        ).data
    );
  }

  upsertUser(data: UpsertUserRequest): Promise<Result<UserResponse>> {
    return result(
      async () =>
        (
          await this.terraClient.post<UserResponse>(
            this.endpoint.getUsersUrl(),
            data
          )
        ).data
    );
  }

  fetchUserRoles(): Promise<Result<UserRolesResponse>> {
    return result(
      async () =>
        (
          await this.terraClient.get<UserRolesResponse>(
            this.endpoint.getUserRolesUrl()
          )
        ).data
    );
  }

  addUserRole(data: UserRoleDescription): Promise<Result<UserRoleResponse>> {
    return result(
      async () =>
        (
          await this.terraClient.post<UserRoleResponse>(
            this.endpoint.getUserRolesUrl(),
            data
          )
        ).data
    );
  }

  fetchProductUsers(productId: string): Promise<Result<ProductUsersResponse>> {
    return result(
      async () =>
        (
          await this.terraClient.get<ProductUsersResponse>(
            this.endpoint.getProductUsersUrl(productId),
            {
              params: {
                pageSize: 50,
              },
            }
          )
        ).data
    );
  }

  addProductUser(
    productId: string,
    user: User,
    role: UserRole
  ): Promise<Result<ProductUserResponse>> {
    return result(
      async () =>
        (
          await this.terraClient.post<ProductUserResponse>(
            this.endpoint.getProductUsersUrl(productId),
            {
              user,
              role,
            }
          )
        ).data
    );
  }

  saveProductUser(
    productId: string,
    user: User,
    role: UserRole
  ): Promise<Result<ProductUserResponse>> {
    return result(
      async () =>
        (
          await this.terraClient.put<ProductUserResponse>(
            this.endpoint.getProductUserDetailUrl(productId, user.id),
            {
              user,
              role,
            }
          )
        ).data
    );
  }
}